
import Vue from "vue";
import {Component} from "vue-property-decorator";
import {mapState} from "vuex";
import moment from "moment";
import axios from "@/plugins/axios";

@Component({
  computed: {
    ...mapState({
      isAuthenticated: 'isAuthenticated'
    })
  }
})
export default class App extends Vue {
  username = ''
  password = ''
  toast = false

  async login() {
    try {
      await axios.post('auth', {
        username: this.username,
        password: this.password
      })
      this.$store.commit('setAuthenticationStatus', true)
      this.$store.commit('setUsername', this.username)
      this.$store.commit('setPassword', this.password)
      this.goToNextPage()
    } catch (err) {
      this.toast = true
      this.$store.commit('setAuthenticationStatus', false)
      return
    }
  }

  goToNextPage() {
    this.$router.push({name: 'Home'})
  }

  get year(): string {
    return moment().format('YYYY')
  }
}
